import { render, staticRenderFns } from "./IncomingChannel.vue?vue&type=template&id=e2548b8e&scoped=true&"
import script from "./IncomingChannel.vue?vue&type=script&lang=js&"
export * from "./IncomingChannel.vue?vue&type=script&lang=js&"
import style0 from "./IncomingChannel.vue?vue&type=style&index=0&id=e2548b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2548b8e",
  null
  
)

export default component.exports